<script>
import { BaseStoryCardElementMixin }
  from "%/dynamic-component-editor/standard-components/base-story-card/base-story-card-element-mixin";
import { useContinueActivityStore } from "%/dynamic-component-editor/stores/continue-activity-store";
import TextElement
  from "%/dynamic-component-editor/standard-elements/text-element/TextElement.vue";
import BrandedTextStyleOptions from "%/dynamic-component-editor/bundles/branded-text-style-options";

const EXAMPLE_LOGGED = 1;
const EXAMPLE_PRESCRIBED = 3;

export default {
  name: "WorkoutSetProgress",
  elementPanelSettings: {
    displayName: "Sets Progress",
    displayIcon: "mdi:dumbbell",
    elementGroup: "storyElements",
    elementType: "element",
  },
  extends: TextElement,
  mixins: [BaseStoryCardElementMixin],
  optionBundles: [
    new BrandedTextStyleOptions({}, {
      "text-option": true,
    }),
  ],
  computed: {
    isEditable() {
      return false;
    },
    isShowingExample() {
      return this.editMode || this.isPreviewMode;
    },
    loggedSets() {
      if (this.isShowingExample) {
        return EXAMPLE_LOGGED;
      }
      return (useContinueActivityStore().setsByStory[this.storyEntityId] ?? []).length;
    },
    prescribedSets() {
      if (this.isShowingExample) {
        return EXAMPLE_PRESCRIBED;
      }
      return useContinueActivityStore().prescribedSetsByStory[this.storyEntityId] ?? 0;
    },
    shouldShowText() {
      return this.prescribedSets > 0;
    },
    value() {
      return `${this.loggedSets} of ${this.prescribedSets} sets`;
    },
  },
  watch: {
    storyEntityId: {
      immediate: true,
      handler(storyId) {
        if (this.isShowingExample || !storyId) {
          return;
        }
        useContinueActivityStore().loadSetLog(storyId);
      },
    },
  },
};
</script>
